<template>
  <validation-observer ref="simpleRules">
    <b-form>

      <!-- Project -->
      <h6>{{ $t('Project') }}</h6>

      <!-- Project Select -->
      <b-form-group
        label=""
        label-for="mc-project"
      >
        <validation-provider
          #default="{ errors }"
          :name="$t('Project')"
          rules="required"
        >
          <v-select
            id="vue-select-project"
            v-model="item.projectId"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="optionProject"
            :reduce="project => project.id"
            label="projectName"
            :placeholder="$t('Select project...')"
            :state="errors.length > 0 ? false:null"
          />
          <small class="text-danger">{{ $t(errors[0]) }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Status -->
      <b-form-group
        :label="$t('Status')"
        label-for="mc-status"
      >
        <b-form-checkbox
          id="checkbox-status-page"
          v-model="item.status"
          name="checkbox-status-page"
          switch
        >
          {{ $t('Active') }}
        </b-form-checkbox>
      </b-form-group>

      <!-- Filter -->
      <h6 v-if="item.projectId">
        {{ $t('Filter') }}
      </h6>

      <form-filter
        v-if="item.projectId"
        v-model="item.filterConfig.filters"
        :project-id="item.projectId"
      />

    </b-form>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import FormFilter from '@/layouts/components/forms/FormFilter.vue'

import {
  BFormGroup, BForm, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BForm,
    BFormCheckbox,
    vSelect,
    FormFilter,
  },
  directives: {
    Ripple,
  },
  props: {
    groupId: {
      type: [Number, String],
      required: true,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      defaultItem: {
        groupId: null,
        projectId: null,
        filterConfigJson: null,
        filterConfig: { filters: [] },
        status: false,
      },
      required,
      optionProject: [],
    }
  },
  computed: {
    item: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        if (this.value) {
          if (!this.value.filterConfigJson) {
            this.$set(this.value, 'filterConfig', { filters: [] })
          }
          return this.value
        }
        return this.defaultItem
      },
    },
  },
  async created() {
    this.getProjectOptions()
  },
  methods: {
    getProjectOptions() {
      useJwt.axiosIns.get('project').then(response => {
        this.optionProject = response.data
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const postItem = JSON.parse(JSON.stringify(this.item))
          postItem.filterConfigJson = JSON.stringify(postItem.filterConfig)
          postItem.groupId = this.groupId
          delete postItem.filterConfig
          if (postItem.id) {
            useJwt.axiosIns.patch('usergroup/userGroupProject', postItem)
              .then(response => {
                if (response.data) {
                  this.$emit('submit')
                }
              })
              .catch(e => {
                console.log(e)
              })
          } else {
            useJwt.axiosIns.post('usergroup/userGroupProject', postItem)
              .then(response => {
                if (response.data) {
                  this.$emit('submit')
                }
              })
              .catch(e => {
                console.log(e)
              })
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
